import { NominalRequest, UploadDocumentPayload } from '@app/models/nominal_payments/NominalPaymentRequest';
import { post, get, remove } from './http.api';
import {
  NominalPaymenAPIData,
  NomPayResponse,
  NomPayTableData,
  NomPayTableRow,
  Parameters,
  UploadDocumentResponse,
  UploadLabDocumentResponse,
} from '@app/models/nominal_payments/NominalPaymentResponse';
import { UploadLabDocumentPayload } from '@app/models/labs/LabRequest';

export const getNomPayData = async (parameters: Parameters): Promise<NomPayTableData> => {
  try {
    const { data, status } = await get<any>(
      'nominal_payments',
      {
        params: parameters,
      },
      true,
    );

    const NomPaytaskdata: NomPayTableRow[] = data.nominal_payments.data.map((NomPayData: any) => ({
      id: NomPayData.id,
      code: NomPayData.code,
      customer_id: NomPayData.customer_id,
      department_id: NomPayData.department_id,
      status: NomPayData.status,
    }));

    return {
      data: NomPaytaskdata,
      pagination: {
        current: data.nominal_payments.current_page,
        pageSize: data.nominal_payments.per_page,
        total: data.nominal_payments.total,
      },
      status_options: data.status_options,
    };
  } catch (error: any) {
    console.error('Error fetching Nominal Payment Tasks:', error);
    throw error;
  }
};

export const getAllNomPayTasks = async (): Promise<NomPayResponse> => {
  try {
    const { data, status } = await get<NomPayResponse>(`nominal_payments`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getNomPayById = async (id: number): Promise<NomPayResponse> => {
  try {
    const { data, status } = await get<NomPayResponse>(`nominal_payments/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeNominalTask = async (nomPayData: NominalRequest) => {
  try {
    const response = await post<any>('/nominal_payments/create', nomPayData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createNominalPayment = async (): Promise<NominalPaymenAPIData> => {
  try {
    const { data, status } = await get<NominalPaymenAPIData>('nominal_payments/create', undefined, true);
    console.log(`Status: ${status}`, `Data:`, data);
    return data;
  } catch (error: any) {
    console.error('Error creating Task:', error);
    throw error;
  }
};

export const showNominalPayment = async (id: number) => {
  try {
    const { data, status } = await get<NominalPaymenAPIData>(`nominal_payments/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editNominalPayment = async (id: number) => {
  try {
    const { data, status } = await get<NominalPaymenAPIData>(`nominal_payments/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateNominalTask = async (id: number, UpdatenomPay: NominalRequest) => {
  try {
    const { data, status } = await post<NominalRequest>(`nominal_payments/${id}/edit`, UpdatenomPay, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateNPStatus = async (id: number, action: any) => {
  try {
    const { data, status } = await post<NominalRequest>(`nominal_payments/${id}/do_action`, action, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const getProductCategoryOptions = async (DeptId: number, type: string) => {
  try {
    const { data, status } = await get<any>(
      `nominal_payments/get_product_category_options`,
      { params: { department_id: DeptId, type: type } },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getProductOptions = async (CatId: number, type: string) => {
  try {
    const { data, status } = await get<any>(
      `nominal_payments/get_product_options`,
      { params: { product_category_id: CatId, type: type } },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getProductVarietyOptions = async (ProId: number, type: string) => {
  try {
    const { data, status } = await get<any>(
      `nominal_payments/get_product_variety_options`,
      { params: { product_id: ProId, type: type } },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getServiceChargeOptions = async (type: string) => {
  try {
    const { data, status } = await get<any>(
      `nominal_payments/get_service_charge_options`,
      { params: { type: type } },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getLabServiceCategories = async (type: string, divId: number) => {
  try {
    const { data, status } = await get<any>(
      `nominal_payments/get_lab_service_category_options`,
      { params: { type: type, division_id: divId } },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getLabServiceOptions = async (type: string, lab_service_category_id: number) => {
  try {
    const { data, status } = await get<any>(
      `nominal_payments/get_lab_service_options`,
      { params: { type: type, lab_service_category_id: lab_service_category_id } },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const getPricing = async (
  type: string,
  category_id: number | null,
  product_id: number | null,
  variety_id: number | null,
  DeptId: number | null,
  days: number | null,
  qty: number,
  pricing_model: string,
  lab_service_id: number | null,
  service_charge_id: number | null,
) => {
  try {
    const { data } = await get<any>(
      `nominal_payments/get_product_pricing`,
      {
        params: {
          type: type,
          product_category_id: category_id ?? null,
          product_id: product_id,
          product_variety_id: variety_id ?? null,
          department_id: DeptId ?? null,
          days: days ?? null,
          qty: qty,
          pricing_model: pricing_model,
          lab_service_id: lab_service_id,
          service_charge_id: service_charge_id,
        },
        paramsSerializer: (params) => {
          const searchParams = new URLSearchParams();
          Object.entries(params).forEach(([key, value]) => {
            searchParams.append(key, value === null ? '' : String(value));
          });
          return searchParams.toString();
        },
      },
      true,
    );
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const uploadDocument = async (
  NomPayId: number,
  payload: UploadDocumentPayload,
): Promise<UploadDocumentResponse> => {
  try {
    const formData = new FormData();
    formData.append('name', payload.name);

    if (payload.id) {
      formData.append('id', payload.id.toString());
    }

    if (payload.file) {
      formData.append('file', payload.file);
    }

    const { data } = await post<UploadDocumentResponse>(`nominal_payments/${NomPayId}/upload_document`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } catch (error: any) {
    console.error('Error uploading lab document:', error);
    throw error;
  }
};

export const generateNPInvoice = async (id: number) => {
  try {
    const response = await post<any>(`nominal_payments/${id}/create_invoice`, undefined, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

// export const setZeroInvoicing = async (id: number, dept_id: number, test_id: number, action: any) => {
//   try {
//     const response = await post<any>(
//       `lab_requests/${id}/lab_request_departments/${dept_id}/lab_request_service_categories/${test_id}/update_billable_with_approved_status`,
//       action,
//       undefined,
//       true,
//     );
//     console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
//     return response.data;
//   } catch (error: any) {
//     console.error(`Error: ${error.status} - ${error.message}`);
//     throw error;
//   }
// };

// export const updateInvoice = async (invoiceId: number) => {
//   try {
//     const response = await post<any>(`invoices/${invoiceId}/set_to_paid`, undefined, undefined, true);
//     console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
//     return response.data;
//   } catch (error: any) {
//     console.error(`Error: ${error.status} - ${error.message}`);
//     throw error;
//   }
// };
